export const CHART_COLORS = [
  "#2f2282", "#1b51a7", "#e8a33d", "#3dab97", "#d9534f", "#5e3f9e", "#3e88d3",
];

export const baseChartOptions = {
  chart: {
    style: { fontFamily: "Roboto, Nunito Sans, Arial, Verdana, Helvetica, sans-serif" },
    backgroundColor: "transparent",
  },
  credits: { enabled: false },
  exporting: { enabled: false },
  title: { text: "" },
  colors: CHART_COLORS,
};
